import React from "react";
import { ArrowRight } from "lucide-react";
import { processSteps, processImage } from "../mock/mock";

const Process = () => {
  const go = () => document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="process" className="section-pad bg-white border-b-2 border-[#0A0A0A]">
      <div className="container-x">
        <div className="max-w-3xl mb-14">
          <p className="eyebrow text-neutral-500">/ How We Work</p>
          <h2 className="mt-4 display text-4xl md:text-5xl font-extrabold uppercase leading-[0.95]">
            Simple. Seamless. <span className="hl">Streamlined</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div className="border-t-2 border-[#0A0A0A]">
            {processSteps.map((s) => (
              <div key={s.step} className="flex gap-6 py-7 border-b-2 border-[#0A0A0A] group">
                <span className="display text-4xl font-extrabold stroke-text group-hover:[-webkit-text-stroke:2px_#0A0A0A] w-16 shrink-0">{s.step}</span>
                <div>
                  <h3 className="display text-xl font-bold uppercase mb-1">{s.title}</h3>
                  <p className="text-neutral-600 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
            <button onClick={go} className="btn-ink mt-8 group">
              Schedule a Call <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>

          <div className="border-2 border-[#0A0A0A] shadow-[10px_10px_0_#0A0A0A]">
            <img src={processImage} alt="Our process" className="w-full h-[500px] object-cover bw" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
